import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportsColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 31L31 9V29C31 30.1046 30.1046 31 29 31H9Z",
			fill: "url(#paint0_angular_320_31602)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 31L28 9V27.1995C28 28.223 27.2273 29.0813 26.2094 29.1885L9 31Z",
			fill: "#AC8EFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 31L28 9V27.1995C28 28.223 27.2273 29.0813 26.2094 29.1885L9 31Z",
			fill: "#AC8EFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 31L22.5 10.5V25.0585C22.5 25.9193 21.9491 26.6836 21.1325 26.9558L9 31Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 31L22.5 10.5V25.0585C22.5 25.9193 21.9491 26.6836 21.1325 26.9558L9 31Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_angular_320_31602",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(15 21.5) rotate(-90) scale(11)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .0189749,
					stopColor: "#AC8EFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .28098,
					stopColor: "#6C73FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .503031,
					stopColor: "#51B7D8"
				})
			]
		}) })
	]
});
export default SvgReportsColored;
